import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=fdf55936&scoped=true&"
import script from "./notification.vue?vue&type=script&lang=ts&"
export * from "./notification.vue?vue&type=script&lang=ts&"
import style0 from "./notification.vue?vue&type=style&index=0&id=fdf55936&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf55936",
  null
  
)

export default component.exports